import { taskAxiosInstance } from "../axiosInstance";

export interface TaskLink {
    id: number;
    taskId: number;
    title: string;
    url: string;
    order: number;
    createdById: number;
    createdAt: string;
    updatedAt: string;
}

export interface CreateTaskLinkInput {
    title: string;
    url: string;
    order?: number;
}

export interface TaskLinkListResponse {
    data: TaskLink[];
    total: number;
}

export const createTaskLink = async (
    taskId: number,
    data: CreateTaskLinkInput,
): Promise<TaskLink> => {
    const response = await taskAxiosInstance.post<TaskLink>("/task-links", {
        taskId,
        title: data.title,
        url: data.url,
        order: data.order,
    });
    return response.data;
};

export const deleteTaskLink = async (id: number): Promise<TaskLink> => {
    const response = await taskAxiosInstance.delete<TaskLink>(`/task-links/${id}`);
    return response.data;
};

export const getTaskLinks = async (taskId: number): Promise<TaskLinkListResponse> => {
    const params = new URLSearchParams();
    params.set("taskId", taskId.toString());
    const response = await taskAxiosInstance.get<TaskLinkListResponse>(
        `/task-links?${params.toString()}`,
    );
    return response.data;
};
